import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import {
  Business,
  Code,
  DarkMode,
  Home,
  Language,
  LightMode,
  LocalHospital,
  Logout,
  Settings,
} from "@mui/icons-material";
import { Toolbar, Typography, useTheme } from "@mui/material";
import { MENU_ITEM } from "../common/constants";
import { useTranslation } from "react-i18next";
import { isAdmin } from "../common/util";
import packageJson from "../../package.json";

export default function MenuDrawer({ visible, onClose }) {
  const theme = useTheme();
  const { t } = useTranslation();
  const toggleDrawer = () => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
  };

  const list = (anchor) => (
    <Box
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <Toolbar>
        <LocalHospital color="secondary" />
        <Typography
          variant="h7"
          component="div"
          sx={{ flexGrow: 1 }}
          ml={2}
          onClick={() => onClose(MENU_ITEM.home)}
        >
          {t("clinic-name")}
        </Typography>
      </Toolbar>
      <Divider />
      <List>
        <ListItemButton onClick={() => onClose(MENU_ITEM.home)}>
          <ListItemIcon sx={{ minWidth: "46px" }}>
            <Home color="secondary" />
          </ListItemIcon>
          <ListItemText primary={t("home")} />
        </ListItemButton>
        {isAdmin() && (
          <ListItemButton onClick={() => onClose(MENU_ITEM.updateSchedule)}>
            <ListItemIcon sx={{ minWidth: "46px" }}>
              <Settings color="secondary" />
            </ListItemIcon>
            <ListItemText primary={t("update-schedule")} />
          </ListItemButton>
        )}
        <ListItemButton onClick={() => onClose(MENU_ITEM.changeTheme)}>
          <ListItemIcon sx={{ minWidth: "46px" }}>
            {theme?.palette?.mode === "light" && <DarkMode color="secondary" />}
            {theme?.palette?.mode === "dark" && <LightMode color="secondary" />}
          </ListItemIcon>
          <ListItemText primary={t("change-theme")} />
        </ListItemButton>
        <ListItemButton onClick={() => onClose(MENU_ITEM.language)}>
          <ListItemIcon sx={{ minWidth: "46px" }}>
            <Language color="secondary" />
          </ListItemIcon>
          <ListItemText primary={t("change-language")} />
        </ListItemButton>

        <ListItemButton onClick={() => onClose(MENU_ITEM.contactUs)}>
          <ListItemIcon sx={{ minWidth: "46px" }}>
            <Business color="secondary" />
          </ListItemIcon>
          <ListItemText primary={t("contact-us")} />
        </ListItemButton>

        {isAdmin() && (
          <ListItemButton onClick={() => onClose(MENU_ITEM.logout)}>
            <ListItemIcon sx={{ minWidth: "46px" }}>
              <Logout color="secondary" />
            </ListItemIcon>
            <ListItemText primary={t("logout")} />
          </ListItemButton>
        )}
      </List>
      <Divider />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          px: 2,
          py: 1.5,
        }}
      >
        <Code sx={{ fontSize: 18, color: "text.secondary" }} />
        <Typography variant="caption" color="text.secondary">
          Developed by Jeyabalaji &nbsp;•&nbsp; v{packageJson.version}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <div>
      <React.Fragment>
        <Drawer anchor="left" open={visible} onClose={onClose}>
          {list("left")}
        </Drawer>
      </React.Fragment>
    </div>
  );
}
